import React, { Component } from 'react'
import PropTypes from 'prop-types'
import footerLinkArray from './FooterMenuLinkArrayConstant'
import { FooterMenuLinkItem } from './FooterMenuLinkItens/index'
import yn from 'yn'

class FooterMenuLinkContent extends Component {
  render () {
    const criteria = this.useEnvironmentForFooter()
    const listItens = this.getItensByCriteria(criteria)
    return listItens.map((value, index) => (
      <FooterMenuLinkItem
        item={value}
      />
    ))
  }

  useEnvironmentForFooter = () => {
    let envFooter = this.getFooterEnvironmentActivated()
    if (envFooter.isEnv) {
      return 'env'
    } else {
      return 'cms'
    }
  }

  getFooterEnvironmentActivated = () => {
    var envsOBJ = {
      REACT_APP_HAS_POINTSANDCASH_LINK: yn(
        process.env.REACT_APP_HAS_POINTSANDCASH_LINK
      ),
      REACT_APP_HAS_SECURITY_LINK: yn(process.env.REACT_APP_HAS_SECURITY_LINK),
      REACT_APP_HAS_REGULATION_LINK: yn(
        process.env.REACT_APP_HAS_REGULATION_LINK
      ),
      REACT_APP_HAS_PRIVACY_LINK: yn(process.env.REACT_APP_HAS_PRIVACY_LINK),
      REACT_APP_HAS_TERMS_LINK: yn(process.env.REACT_APP_HAS_TERMS_LINK),
      REACT_APP_HAS_FAQ_LINK: yn(process.env.REACT_APP_HAS_FAQ_LINK),
      REACT_APP_HAS_CONTACT_LINK: yn(process.env.REACT_APP_HAS_CONTACT_LINK)
    }
    let envsActivated = []
    let isNull = 0
    for (const [key, value] of Object.entries(envsOBJ)) {
      if (value !== null) {
        if (value) {
          envsActivated.push(key)
        }
      } else {
        isNull++
      }
    }
    let isEnv = isNull !== 7
    return { isEnv, envsActivated }
  }

  getItensByCriteria = criteria => {
    if (criteria === 'cms') {
      return this.getCMSArraylinks()
    } else {
      return this.getEnvArrayLinks()
    }
  }

  getEnvArrayLinks = () => {
    let arrayEnvironmentActivated = this.getFooterEnvironmentActivated()
    let arrayLinks = footerLinkArray
    arrayLinks = arrayLinks.filter(item => {
      return arrayEnvironmentActivated.envsActivated.includes(item.type)
    })

    return arrayLinks.length > 0 ? arrayLinks : []
  }

  getCMSArraylinks = () => {
    let itens = this.props.footerMenu.items
    let formattedItens = itens.map((el, index) => {
      let pathSplitArray = el.path.split('/')
      let classNameFormatted = pathSplitArray[pathSplitArray.length - 1]
      let formattedOBJ = {
        type: classNameFormatted,
        className: 'link-' + classNameFormatted,
        dataHrefTo: el.path,
        description: el.label
      }
      return formattedOBJ
    })
    return formattedItens.length > 0 ? formattedItens : []
  }
}

FooterMenuLinkContent.propTypes = {
  footerMenu: PropTypes.object
}

export default FooterMenuLinkContent



// WEBPACK FOOTER //
// ./src/App/Footer/FooterMenuLinks/FooterMenuLinkContent.js